import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=5d0a5083"
import script from "./normal.vue?vue&type=script&lang=js"
export * from "./normal.vue?vue&type=script&lang=js"
import style0 from "./normal.vue?vue&type=style&index=0&id=5d0a5083&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports